import PaginationDataModelBase from '../_generated/modelBases/pagination-data-model-base';

export default class PaginationDataModel extends PaginationDataModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
